<template>
  <PageWrapper
    :active-section="SECTION_SETTINGS"
    :active-page="PAGE_ADVERTISING_SETTINGS"
    title="Advertisements"
    :breadcrumbs="breadcrumbs"
    page-name="My Ads"
    align="center"
    width="full"
  />
</template>

<script>
import PageWrapper from "@/components/PageWrapper";
import { PAGE_ADVERTISING_SETTINGS, SECTION_SETTINGS } from "@/constants/nav-constants";
import { mapState } from "pinia";
import { useGeneralStore } from "%/stores/general-store";

export default {
  name: "Advertising",
  components: {
    PageWrapper,
  },
  data() {
    return {
      SECTION_SETTINGS,
      PAGE_ADVERTISING_SETTINGS,
    };
  },
  computed: {
    ...mapState(useGeneralStore, ["orgId"]),
    breadcrumbs() {
      return [{ url: "/", label: "Home" }, { label: "Advertisements" }];
    },
  },
};
</script>
